import React, { useState, useEffect, useRef } from 'react';
import { FaFilter, FaPhone, FaEnvelope, FaComment, FaCheck, FaTimes, FaChevronRight, FaChevronLeft, FaTimes as FaClose, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { IoCallOutline } from "react-icons/io5";
import server from '../../../api/server.js';
import '../../../dashboard-components/loader.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigateWithCurrentQuery } from '../../../utils/routerUtils';
import ModernTimeDropdown from '../../../dashboard-components/layouts/modernDropdown';
import CallDetails from './CallDetails';
import ModernDatePicker from '../../../dashboard-components/layouts/ModernDatePicker';
import { Download } from 'lucide-react';
import { useToast } from '../../../context/ToastContext.jsx';
import VoiceCallDownloadParametersModal from './VoiceCallDownloadParametersModal.jsx';
import { buildVoiceAgentCallsDownloadBody } from '../../../utils/voiceAgentDownloadPayload.js';
import { IoChatbubbleOutline } from "react-icons/io5";
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { FaCaretDown, FaCaretRight } from "react-icons/fa";
import { initializeFiltersFromUrl, updateUrlWithFilters, getListPageFromLocation, parseQueryToFilters } from '../../../utils/filterUtils.js';

const ConversationRecords = ({serviceID, type, clientID, segment}) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  // Default filter values
  const defaultFilters = {
    agent: '',
    time: 'Last 7 Days',
    conversation_id: '',
    record_type: 'call',
    customStart: '',
    customEnd: "",
    mode: 'Live Conversation'
  };

  const defaultAdvancedFilters = {
    type: '',
    customer_id: '',
    audioDuration: '',
    conversation_direction: '',
    disconnect_type: '',
    disconnect_reason: '',
    average_latency: '',
    campaign_id: '',
    campaign_batch_id: '',
    transfer_status: '',
    transfer_agent_answered: '',
    crm_update_status: '',
    agent_feedback_multiple: [],
    business_insights_multiple: []
  };

  // Initialize filters from URL or use defaults (only when not passed via segment prop)
  const initialFilterState = !segment ? initializeFiltersFromUrl(location, defaultFilters, defaultAdvancedFilters) : {
    filters: defaultFilters,
    advancedFilters: defaultAdvancedFilters,
    customStart: '',
    customEnd: ''
  };

  // Track which filters actually came from URL so they take precedence over segment/role defaults
  const { filters: urlInitFilters, advancedFilters: urlInitAdvanced, customStart: urlInitCustomStart, customEnd: urlInitCustomEnd } = parseQueryToFilters(new URLSearchParams(location.search));
  const urlFiltersRef = useRef(urlInitFilters || {});
  const urlAdvancedFiltersRef = useRef(urlInitAdvanced || {});
  const urlCustomStartRef = useRef(urlInitCustomStart || '');
  const urlCustomEndRef = useRef(urlInitCustomEnd || '');

  const [email, setEmail] = useState(null)
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0)
  const [queuedCalls, setQueuedCalls] = useState([])
  const [showQueuedCalls, setShowQueuedCalls] = useState(false)
  const [showCancelQueuedCallModal, setShowCancelQueuedCallModal] = useState(false)
  const [cancelQueuedCall, setCancelQueuedCall] = useState(null)
  const [cancelQueuedCallApiRunning, setCancelQueuedCallApiRunning] = useState(false)
  const [originalSize, setOriginalSize] = useState(0)
  const [filteredConversations, setFilteredConversations] = useState([]);
  const [client_id, setClient_id] = useState(null)
  const [service_id, setService_id] = useState(null)
  const [openType, setOpenType] = useState(null)
  const [selectedCallID, setSelectedCallID] = useState(null)
  const [segmentParameterData, setSegmentParameterData] = useState({'type':null, 'id': null, 'name': null})
  const [expandedSections, setExpandedSections] = useState({
    agentFeedback: false,
    businessInsights: false,
    concernsAndQueries: false,
    dispositionAndSubdisposition: false
  });
  const [filters, setFilters] = useState(initialFilterState.filters);
  const [advancedFilters, setAdvancedFilters] = useState(initialFilterState.advancedFilters);
  const isVoiceFilter = (filters.record_type || 'call') === 'call';
  const queuedCallsEnabled = showQueuedCalls && isVoiceFilter;
  useEffect(() => {
    if (!isVoiceFilter) setShowQueuedCalls(false);
  }, [isVoiceFilter]);
  const [page, setPage] = useState(() => (!segment && !type ? getListPageFromLocation(location) : 1));
  const [totalPages, setTotalPages] = useState(1);
  const [apiCallRunning, setApiCallRunning] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dummyFilterData, setDummyFilterData] = useState({
    agents: [],
    modes: ['Live Conversation', 'Test Conversation'],
    times: ['Today',
      'Yesterday',
      'This Week',
      "This Month",
      "Last Month",
      "Last 7 Days",
      "Last 30 Days",
      "Last 3 Months",
      "Custom Range"],
  });
  const [role] = useState(()=> {
    const userCookie = getCookie('dashboard_login_user_creds');
    if (userCookie) {
      const userData = JSON.parse(userCookie);
      const role = userData.role
      return role
    }
    return 'admin';
  })
  let [dummyAdvancedFilterData, setDummyAdvancedFilterData] =useState({
    refusal_category: [],
    conversation_outcome: [],
    open_concerns_and_queries: ['Yes', 'No'],
    audioDuration: ['Less than 1 Minute', '1-2 Minutes', '3-5 Minutes', 'Above 2 Minutes', 'More than 5 Minutes'],
    conversation_potential: [],
    agent_feedback_parameters: [],
    concern_categories: [],
    concern_subcategories: [],
    query_categories: [],
    query_subcategories: [],
    disposition: [],
    subdisposition: [],
    lead_sources: [],
    tags: [],
    disconnect_types: [],
    disconnect_reasons: [],
    conversation_directions: [],
    campaign_ids: [],
    campaign_batch_ids: [],
    transfer_statuses: [],
    transfer_agent_answereds: [],
    business_insights: []
  })
  const [showConversationPage, setShowConversationPage] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [filterMode, setFilterMode] = useState('quick');
  const [conversationIds, setConversationIds] = useState([]);
  const [customerIds, setCustomerIds] = useState([]);
  // Update URL whenever filters change (only if not using segment prop)
  useEffect(() => {
    if (!type && client_id) { // Only update URL for standalone usage, not when embedded as modal
      // Debounce URL updates to avoid conflicts with navigation
      const timeoutId = setTimeout(() => {
        updateUrlWithFilters(navigate, location, filters, advancedFilters, filters.customStart, filters.customEnd, page);
      }, 300);
      
      return () => clearTimeout(timeoutId);
    }
  }, [filters, advancedFilters, type, client_id, page]); // Removed navigate and location from deps

  useEffect(() => {
    if (segment || type) return;
    const fromUrl = getListPageFromLocation(location);
    setPage((p) => (p !== fromUrl ? fromUrl : p));
  }, [location.search, segment, type]);

  function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}
  const getAudioDurationValueForApi = (valueObj = advancedFilters) => {
    if (valueObj.audioDuration !== 'Custom Range') {
      return valueObj.audioDuration;
    }
    const lower = valueObj.audioDurationLower;
    const upper = valueObj.audioDurationUpper;
    if (lower === null || lower === undefined || lower === '' || upper === null || upper === undefined || upper === '') {
      return '';
    }
    const lowerNum = Number(lower);
    const upperNum = Number(upper);
    if (Number.isNaN(lowerNum) || Number.isNaN(upperNum) || lowerNum < 0 || upperNum < 0 || lowerNum > upperNum) {
      return '';
    }
    return `${lowerNum}-${upperNum}`;
  };

  const downloadConversations = async (parametersJson, downloadFilterMode, convoIds = [], custIds = []) => {
    showToast("We're preparing your download. You'll receive an email with the link shortly.", 'success');
    let parametersList = [];
    try {
      const parsed = JSON.parse(parametersJson);
      if (Array.isArray(parsed)) parametersList = parsed;
    } catch {
      parametersList = [];
    }
    const body = buildVoiceAgentCallsDownloadBody({
      clientId: client_id,
      serviceId: service_id,
      email,
      parametersList,
      filterType: downloadFilterMode,
      conversationIds: convoIds,
      customerIds: custIds,
      totalRecords,
      filters,
      advancedFilters,
      segmentParameterData,
      getAudioDurationValueForApi: () => getAudioDurationValueForApi()
    });
    try {
      const res = await server.postVoiceAgentCallsDownloadRequest(body);
      if (!res.ok) {
        showToast('Could not queue your download. Please try again later', 'error');
      }
    } catch (error) {
      console.error('Download conversations failed:', error);
      showToast('Something went wrong. Please try again later', 'error');
    }
  };

  const captureRecords = async (payload) => {
    setIsDownloadModalOpen(false);
    const { parametersJson, filterMode: dlMode, parsedIds } = payload;
    if (dlMode === 'conversation_ids') {
      await downloadConversations(parametersJson, dlMode, parsedIds, []);
    } else if (dlMode === 'customer_ids') {
      await downloadConversations(parametersJson, dlMode, [], parsedIds);
    } else {
      await downloadConversations(parametersJson, dlMode, [], []);
    }
  };

  const formatEpochToReadableDate = (epoch) => {
    const date = new Date(epoch*1000); // Convert seconds to milliseconds
    const options = { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
    return date.toLocaleString('en-GB', options).replace(',', '');
  };

  const [conversations, setConversations] = useState([]);

  const handleQuickFilterChange = (e, key) => {
    const value = e.target.value;
    
    // If changing time filter and it's not "Custom Range", clear the custom date values
    if (key === 'time' && value !== 'Custom Range') {
      setFilters((prev) => ({ 
        ...prev, 
        [key]: value,
        customStart: '',
        customEnd: ''
      }));
    } else {
      setFilters((prev) => ({ ...prev, [key]: value }));
    }
  };
  const handleAdvancedInputChange = (e, key) => {
    const value = e.target.value;
    setAdvancedFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const callsAbortRef = useRef(null);

  const get_calls_page_details = async (client_id, service_id, page_size) => {
    // If another request exists, abort it; we'll launch a new one immediately
    if(callsAbortRef.current){
      callsAbortRef.current.abort();
    }
    const controller = new AbortController();
    callsAbortRef.current = controller;

    try {
      setApiCallRunning(true)
      setLoading(true)
      // Guard: if any Business Insight row has a key without a value (or vice versa), skip the API call
      const biFilters = Array.isArray(advancedFilters.business_insights_multiple) ? advancedFilters.business_insights_multiple : [];
      if (biFilters.length > 0) {
        const hasIncomplete = biFilters.some((item) => {
          const k = (item?.business_insight_key ?? '').toString().trim();
          const v = (item?.business_insight_value ?? '').toString().trim();
          return k.length === 0 || v.length === 0;
        });
        if (hasIncomplete) {
          setApiCallRunning(false);
          setLoading(false);
          return;
        }
      }

      let res = await server.get_voice_agent_calls_list(client_id, service_id, email, 'conversations', undefined, page_size, filters.conversation_id, filters.agent, filters.time, filters.customStart, filters.customEnd, advancedFilters.audioDuration, advancedFilters.conversation_direction, advancedFilters.customer_id, advancedFilters.disconnect_type, advancedFilters.disconnect_reason, advancedFilters.average_latency, advancedFilters.campaign_id, advancedFilters.campaign_batch_id, filters.mode, advancedFilters.transfer_status, advancedFilters.transfer_agent_answered, JSON.stringify(advancedFilters.business_insights_multiple), advancedFilters.crm_update_status, filters.record_type || 'call')
        if(res.status === 200){
          let resp = await res.json()
          setConversations(resp.data)
          setFilteredConversations(resp.data)
          const totalRecords = resp.total_records;
          setTotalRecords(totalRecords)
          setOriginalSize(totalRecords)
          setTotalPages(Math.ceil(totalRecords / 50));
          setApiCallRunning(false)
          // Stop page-level loading as soon as call-data arrives
          setLoading(false);
        }else{
          showToast('Something went wrong. Please try again later', 'error')
          setApiCallRunning(false)
          setLoading(false)
        }
    } catch (error) {
      if(error.name === 'AbortError'){
        setApiCallRunning(false);
        return; // silently ignore aborted request
      }
      setApiCallRunning(false)
      setLoading(false)
    }
  }

  // Fetch quick-filter dropdown data once at mount or when IDs/email set
  const fetchFilterDetailsOnce = async () => {
    try {
      const res = await server.getVoiceAgentsMetricsFilters(client_id, service_id, email, 'conversations', undefined);
      if(res.status === 200){
        const data = await res.json();
        setDummyFilterData(prev => ({ ...prev, agents: data.agents }));
        setDummyAdvancedFilterData(prev => ({
          ...prev,
          disconnect_types: data.disconnect_types,
          disconnect_reasons: data.disconnect_reasons,
          conversation_directions: data.conversation_directions,
          campaign_ids: data.campaign_ids,
          campaign_batch_ids: data.campaign_batch_ids,
          transfer_statuses: data.transfer_statuses,
          transfer_agent_answereds: data.transfer_agent_answered,
          business_insights: data.business_insights
        }));
      }
    } catch(err) {  }
  }

  useEffect(()=>{
    if(client_id && email){
      fetchFilterDetailsOnce();
    }
  }, [client_id, service_id, email]);
  const handleCallDetail = (id) => {
    if (openType === 'modal-open'){
      setSelectedCallID(id)
      setShowConversationPage(true);
      return;
    }
    const encodedCallId = encodeURIComponent(id);
    let url = `/voice-agents/${client_id}/${service_id}/conversations/${encodedCallId}`
    // Flush current filters + page to URL immediately to avoid debounce race before navigating
    updateUrlWithFilters(navigate, location, filters, advancedFilters, filters.customStart, filters.customEnd, page);
    navigateWithCurrentQuery(navigate, location, url)
  }
  const handleClose = (e) => {
    setShowConversationPage(false);
  }

  // Hard resync filters from URL on arrival or when query changes
  // Skip this when used as a modal (type prop present) to avoid persisting previous page filters
  useEffect(() => {
    if (type) return;
    const { filters: fromUrlFilters, advancedFilters: fromUrlAdvanced, customStart: fromUrlCustomStart, customEnd: fromUrlCustomEnd } = parseQueryToFilters(new URLSearchParams(location.search));
    // Merge URL -> state for basic filters
    if (fromUrlFilters || fromUrlAdvanced || fromUrlCustomStart || fromUrlCustomEnd) {
      setFilters(prev => {
        const merged = { ...prev };
        Object.keys(defaultFilters).forEach(k => {
          if (fromUrlFilters && fromUrlFilters[k] !== undefined) {
            merged[k] = fromUrlFilters[k];
          }
        });
        if (fromUrlCustomStart) merged.customStart = fromUrlCustomStart;
        if (fromUrlCustomEnd) merged.customEnd = fromUrlCustomEnd;
        // Avoid new object when only pagination (`page`) changed in the URL — that retriggered filter debounce and reset page
        try {
          if (JSON.stringify(merged) === JSON.stringify(prev)) return prev;
        } catch (_) {}
        return merged;
      });
      setAdvancedFilters(prev => {
        const mergedA = { ...prev };
        Object.keys(defaultAdvancedFilters).forEach(k => {
          if (fromUrlAdvanced && fromUrlAdvanced[k] !== undefined) {
            mergedA[k] = fromUrlAdvanced[k];
          }
        });
        try {
          if (JSON.stringify(mergedA) === JSON.stringify(prev)) return prev;
        } catch (_) {}
        return mergedA;
      });
    }
  }, [location.search, type]);

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const sliderTrackRef = useRef(null);
  const isDraggingLower = useRef(false);
  const isDraggingUpper = useRef(false);
  // Ref to debounce filter change API calls
  const filtersDebounceRef = useRef(null);
  const firstFiltersLoadRef = useRef(true); // to skip debounce on initial mount
  const isInitializingRef = useRef(false); // to prevent API calls during initialization
  const prevAdvancedFiltersRef = useRef(advancedFilters); // track previous to detect partial BI key selection
  
  // Handle mouse events for both thumbs
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!sliderTrackRef.current || (!isDraggingLower.current && !isDraggingUpper.current)) return;
      
      const rect = sliderTrackRef.current.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const percentage = Math.min(Math.max((offsetX / rect.width) * 100, 0), 100);
      
      if (isDraggingLower.current) {
        const newValue = Math.min(percentage, advancedFilters.scoreUpper - 1);
        setAdvancedFilters(prev => ({ ...prev, scoreLower: newValue }));
      } else if (isDraggingUpper.current) {
        const newValue = Math.max(percentage, advancedFilters.scoreLower + 1);
        setAdvancedFilters(prev => ({ ...prev, scoreUpper: newValue }));
      }
    };

    const handleMouseUp = () => {
      isDraggingLower.current = false;
      isDraggingUpper.current = false;
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [advancedFilters.scoreLower, advancedFilters.scoreUpper]);
  
  const handleNumberInputChange = (e, type) => {
    const value = e.target.value;
    
    // if (isNaN(value)) return;
    
    if (type === 'scoreLower') {
      setAdvancedFilters(prev => ({ ...prev, scoreLower: value}));
    } else if (type === 'scoreUpper') {
      setAdvancedFilters(prev => ({ ...prev, scoreUpper: value }));
    } else if(type === 'agentFeedbackParameterScoreLower'){
      setAdvancedFilters(prev => ({...prev, agentFeedbackParameterScoreLower: value}))
    }else if(type === 'agentFeedbackParameterScoreUpper'){
      setAdvancedFilters(prev => ({...prev, agentFeedbackParameterScoreUpper: value}))
    }
  };

  useEffect(()=> {
    // Set initialization flag to prevent filter effect from triggering API calls
    isInitializingRef.current = true;
    
    const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
      if (user) {
        setEmail(user.email);
      }
      if(serviceID){
        setService_id(serviceID)
      }
      if(clientID){
        setClient_id(clientID)
      }
      if(type){
        setOpenType(type)
      }
      if(segment){
        // Clear previous segment-specific key if different (prevents stale filter sticking)
        if (segmentParameterData?.id && segmentParameterData.id !== segment.id) {
          setAdvancedFilters((prev) => ({ ...prev, [segmentParameterData.id]: null }));
        }
        setSegmentParameterData(segment)
        // Apply segment filters (always override with current segment selection)
        if(segment.filter_applied?.time){
          handleQuickFilterChange({'target': {'value': segment.filter_applied.time}}, 'time')
          if(segment.filter_applied.time === 'Custom Range' && segment.filter_applied.customStart && segment.filter_applied.customEnd){
            setFilters((prev) => ({ ...prev, 'customStart': segment.filter_applied.customStart }));
            setFilters((prev) => ({ ...prev, 'customEnd': segment.filter_applied.customEnd }));
          }
        }
        if(segment.filter_applied?.agent){
          handleQuickFilterChange({'target': {'value': segment.filter_applied.agent}}, 'agent')
        }
        if(segment.filter_applied?.audioduration){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.audioduration}}, 'audioDuration')
        }
        if(segment.filter_applied?.record_type){
          handleQuickFilterChange({'target': {'value': segment.filter_applied.record_type}}, 'record_type')
        }
        if(segment.filter_applied?.concernSubcategory){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.concernSubcategory}}, 'concernSubcategory')
        }
        if(segment.filter_applied?.querySubcategory){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.querySubcategory}}, 'querySubcategory')
        }
        if(segment.filter_applied?.concernCategory){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.concernCategory}}, 'concernCategory')
        }
        if(segment.filter_applied?.queryCategory){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.queryCategory}}, 'queryCategory')
        }
        if(segment.filter_applied?.lead_source){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.lead_source}}, 'lead_source')
        }
        if(segment.filter_applied?.tag){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.tag}}, 'tag')
        }
        if(segment.filter_applied?.conversation_type){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.conversation_type}}, 'type')
        }
        if(segment.filter_applied?.conversationPotential){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.conversationPotential}}, 'conversationPotential')
        }
        if(segment.filter_applied?.conversation_direction){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.conversation_direction}}, 'conversation_direction')
        }
        if(segment.filter_applied?.customerId){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.customerId}}, 'customer_id')
        }
        if(segment.filter_applied?.type){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.type}}, 'type')
        }
        // New BI mapping: prefer business_insight_key/value if present
        if(segment.filter_applied?.business_insight_key && segment.filter_applied?.business_insight_value){
          setAdvancedFilters((prev) => ({ ...prev, business_insights_multiple: [{'business_insight_key': segment.filter_applied.business_insight_key, 'business_insight_value': segment.filter_applied.business_insight_value}] }));
          if(segment.id && segment.name){ 
            setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
          }
        } else if(segment.filter_applied?.businessInsightParameter && segment.filter_applied?.businessInsightValue){
          // Backward compatibility
          setAdvancedFilters((prev) => ({ ...prev, business_insights_multiple: [{'business_insights_parameter': segment.filter_applied.businessInsightParameter, 'business_insights_parameter_value': segment.filter_applied.businessInsightValue}] }));
          if(segment.id && segment.name){ 
            setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
          }
        }
        if(segment.filter_applied?.campaign_batch_id){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.campaign_batch_id}}, 'campaign_batch_id')
        }
        if(segment.filter_applied?.campaign_id){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.campaign_id}}, 'campaign_id')
        }
        if(segment.filter_applied?.business_insights_multiple){
          setAdvancedFilters((prev) => ({ ...prev, business_insights_multiple: segment.filter_applied.business_insights_multiple }));
          if(segment.id && segment.name){ 
            setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
          }
        }
        if(segment.filter_applied?.agentFeedbackParameter && segment.filter_applied?.agentFeedbackParameterScoreLower && segment.filter_applied?.agentFeedbackParameterScoreUpper){
          setAdvancedFilters((prev) => ({ ...prev, agent_feedback_multiple: [{'agent_feedback_parameter': segment.filter_applied.agentFeedbackParameter, 'agent_feedback_parameter_score_lower': segment.filter_applied.agentFeedbackParameterScoreLower, 'agent_feedback_parameter_score_upper': segment.filter_applied.agentFeedbackParameterScoreUpper}] }));
          if(segment.id && segment.name){ 
            setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
          }
        }
        if(segment.filter_applied?.agent_feedback_multiple){
          setAdvancedFilters((prev) => ({ ...prev, agent_feedback_multiple: segment.filter_applied.agent_feedback_multiple }));
          if(segment.id && segment.name){ 
            setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
          }
        }
        if(segment.filter_applied?.disconnect_type){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.disconnect_type}}, 'disconnect_type')
        }
        if(segment.filter_applied?.disconnect_reason){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.disconnect_reason}}, 'disconnect_reason')
        }
        if(segment.filter_applied?.transfer_status){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.transfer_status}}, 'transfer_status')
        }
        if(segment.filter_applied?.transfer_agent_answered){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.transfer_agent_answered}}, 'transfer_agent_answered')
        }
        if(segment.filter_applied?.crm_update_status){
          handleAdvancedInputChange({'target': {'value': segment.filter_applied.crm_update_status}}, 'crm_update_status')
        }
        if(segment.id === 'chats'){
          handleQuickFilterChange({'target': {'value': 'chat'}}, 'record_type')
          setFilters((prev) => ({ ...prev, 'chats': null }));
        }
        if(segment.id === 'calls'){
          handleQuickFilterChange({'target': {'value': 'call'}}, 'record_type')
          setFilters((prev) => ({ ...prev, 'calls': null }));
        }
        if(segment.id && segment.name){
          // setFilters((prev) => ({ ...prev, [segment.id]: segment.name }));
          setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name }));
        }
      }
      if(role === 'agent' && !urlInitFilters.agent){
        handleQuickFilterChange({'target': {'value': user.name}}, 'agent')
      }

      if(segment?.filter_applied?.disconnect_type && !urlAdvancedFiltersRef.current.disconnect_type){
        handleAdvancedInputChange({'target': {'value': segment.filter_applied.disconnect_type}}, 'disconnect_type')
      }
      if(segment?.filter_applied?.disconnect_reason && !urlAdvancedFiltersRef.current.disconnect_reason){
        handleAdvancedInputChange({'target': {'value': segment.filter_applied.disconnect_reason}}, 'disconnect_reason')
      }
      if(segment?.filter_applied?.transfer_status && !urlAdvancedFiltersRef.current.transfer_status){
        handleAdvancedInputChange({'target': {'value': segment.filter_applied.transfer_status}}, 'transfer_status')
      }
      if(segment?.filter_applied?.transfer_agent_answered && !urlAdvancedFiltersRef.current.transfer_agent_answered){
        handleAdvancedInputChange({'target': {'value': segment.filter_applied.transfer_agent_answered}}, 'transfer_agent_answered')
      }
      if(segment?.filter_applied?.crm_update_status && !urlAdvancedFiltersRef.current.crm_update_status){
        handleAdvancedInputChange({'target': {'value': segment.filter_applied.crm_update_status}}, 'crm_update_status')
      }

      // Clear initialization flag after a short delay to ensure all state updates are processed
      const initTimeout = setTimeout(() => {
        isInitializingRef.current = false;
      }, 100);
      
      return () => {
        clearTimeout(initTimeout);
      };
  }, [serviceID, clientID, role, segment])


  const toggleAdvancedFilters = () => {
    setShowAdvancedFilters(!showAdvancedFilters);
  };

  const getScoreBar = (score) => {
    if(score === null){
      return ""
    }
    let color = 'bg-green-500';
    let width = `${score}%`;
    
    
    
    return (
      <div className="w-16 bg-gray-200 rounded h-2">
        <div className={`h-2 rounded ${color}`} style={{ width }}></div>
      </div>
    );
  };

  const getModeIcon = (mode) => {
    switch (mode) {
      case 'call':
        return <IoCallOutline className="text-blue-700" />;
      case 'email':
        return <FaEnvelope className="text-blue-500" />;
      case 'chat':
        return <IoChatbubbleOutline className="text-blue-700" />;
      default:
        return <IoCallOutline className="text-blue-700" />;
    }
  };

  // Effect to fetch data whenever page or fatal toggle changes
  useEffect(() => {
    if(!client_id) return;
    if (queuedCallsEnabled) {
      getQueuedCalls(page);
    } else {
      get_calls_page_details(client_id, service_id, page);
    }
  }, [client_id, service_id, queuedCallsEnabled, page]);

  // Debounce API calls when filters change to avoid rapid requests while typing
  useEffect(() => {
    if (!client_id) return;

    // Skip debounce logic on initial mount to avoid duplicate first fetch
    if (firstFiltersLoadRef.current) {
      firstFiltersLoadRef.current = false;
      prevAdvancedFiltersRef.current = advancedFilters;
      return;
    }

    // Skip API calls during initialization to prevent multiple calls on page reload
    if (isInitializingRef.current) {
      prevAdvancedFiltersRef.current = advancedFilters;
      return;
    }

    // If the only change is selecting a BI key without a value, skip API call until value is chosen
    try {
      const prevAdv = prevAdvancedFiltersRef.current || {};
      const currAdv = advancedFilters || {};
      const { business_insights_multiple: prevBI = [], ...prevRest } = prevAdv;
      const { business_insights_multiple: currBI = [], ...currRest } = currAdv;
      const othersEqual = JSON.stringify(prevRest) === JSON.stringify(currRest);
      const hasPartialCurr = Array.isArray(currBI) && currBI.some((it) => (it?.business_insight_key || '') !== '' && (it?.business_insight_value == null || it?.business_insight_value === ''));
      const biKeyChangedWithoutValue = Array.isArray(currBI) && currBI.some((it, idx) => {
        const prevIt = prevBI[idx] || {};
        const keyChanged = (it?.business_insight_key || '') !== (prevIt?.business_insight_key || '');
        const valueEmpty = (it?.business_insight_value == null || it?.business_insight_value === '');
        return keyChanged && valueEmpty;
      });
      if (othersEqual && hasPartialCurr && biKeyChangedWithoutValue) {
        prevAdvancedFiltersRef.current = advancedFilters;
        return;
      }
    } catch (_) {}

    // Clear previous debounce timer
    if (filtersDebounceRef.current) {
      clearTimeout(filtersDebounceRef.current);
    }

    filtersDebounceRef.current = setTimeout(() => {
      // Only reset to first page; page effect will handle fetching once
      if (page !== 1) {
        setPage(1);
      } else {
          if (queuedCallsEnabled) {
            getQueuedCalls(1);
          } else {
            get_calls_page_details(client_id, service_id, 1);
          }
      }
    }, 600); // idle delay

    return () => {
      if (filtersDebounceRef.current) {
        clearTimeout(filtersDebounceRef.current);
      }
    };
  }, [filters, advancedFilters, client_id, service_id, queuedCallsEnabled]);


  const getQueuedCalls = async (page) => {
    try {
      setLoading(true)
      let res = await server.getQueuedCalls(client_id, '', email, page, 'conversations', undefined, filters.time, filters.customStart, filters.customEnd, filters.agent, filters.conversation_id)
      if(res.status === 200){
        let resp = await res.json()
        setQueuedCalls(resp.data)
        const totalRecords = resp.total_records;
        setTotalRecords(totalRecords)
        setTotalPages(Math.ceil(totalRecords / 50));
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const CancelQueuedCallModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;
    return (
      <div style={{zIndex: '9999999999', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', background: 'rgba(0,0,0, 0.5)'}}>
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative">
            <div className="flex justify-between items-center p-4 pb-2">
              <h2 className="text-xl text-gray-700" style={{fontWeight: '550'}}>Cancel Call</h2>
              <button onClick={onClose} disabled={cancelQueuedCallApiRunning} className="text-gray-500 hover:text-gray-700 disabled:cursor-not-allowed" aria-label="Close confirmation modal">
                <FaTimes style={{color: 'slategray'}} />
              </button>
            </div>
            <div className="p-6 pt-2 text-sm text-gray-600">
              Are you sure you want to cancel this call?
            </div>
            <div className="flex justify-end gap-3 p-6 pt-6">
              <button
                onClick={onClose}
                className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed"
                style={{height: '40px', borderRadius: '4px'}}
                disabled={cancelQueuedCallApiRunning}
              >
                No
              </button>
              <button
                onClick={onConfirm}
                disabled={cancelQueuedCallApiRunning}
                className={`px-6 py-2 rounded-lg ${cancelQueuedCallApiRunning ? 'bg-gray-500 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'} text-white`}
                style={{height: '40px', borderRadius: '4px'}}
              >
                Yes, Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  const handleConfirmCancelQueuedCall = async () => {
    if (!cancelQueuedCall) return;
    try {
      setCancelQueuedCallApiRunning(true);
      const resp = await server.cancel_voice_agent_queued_call(
        client_id,
        service_id,
        email,
        'conversations',
        undefined,
        cancelQueuedCall.processing_id,
        cancelQueuedCall.conversation_id,
      );
      if (resp.status === 200) {
        showToast('Call cancelled successfully.', 'success');
        setShowCancelQueuedCallModal(false);
        setCancelQueuedCall(null);
        setPage(1);
        await getQueuedCalls(1);
      } else if (resp.status === 409) {
        showToast('This call is no longer pending and cannot be cancelled.', 'error');
        setShowCancelQueuedCallModal(false);
        setCancelQueuedCall(null);
        setPage(1);
        await getQueuedCalls(1);
      } else {
        showToast('Failed to cancel call.', 'error');
      }
    } catch (e) {
      showToast('Failed to cancel call.', 'error');
    } finally {
      setCancelQueuedCallApiRunning(false);
    }
  };

  // Helper functions for updating array items
  const updateAgentFeedback = (index, field, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      agent_feedback_multiple: prev.agent_feedback_multiple.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const updateBusinessInsights = (index, field, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      business_insights_multiple: prev.business_insights_multiple.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };
  // Business Insights helpers
  const getBusinessInsightKeys = () => {
    const src = dummyAdvancedFilterData.business_insights;
    if (!src) return [];
    if (Array.isArray(src)) {
      // [['key', ['v1','v2']], ...] or ['k1','k2']
      if (src.length > 0 && Array.isArray(src[0])) {
        return src.map(([k]) => k.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()));
      }
      return src.map(k => String(k).replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()));
    }
    if (typeof src === 'object') {
      return Object.keys(src).map(k => k.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()));
    }
    return [];
  };
  const getBusinessInsightValues = (selectedKeyDisplay) => {
    const src = dummyAdvancedFilterData.business_insights;
    if (!src || !selectedKeyDisplay) return [];
    const keySnake = selectedKeyDisplay.toLowerCase().replace(/ /g, '_');
    if (Array.isArray(src)) {
      if (src.length > 0 && Array.isArray(src[0])) {
        const found = src.find(([k]) => k === keySnake || k.replace(/_/g, ' ').toLowerCase() === selectedKeyDisplay.toLowerCase());
        return found ? (Array.isArray(found[1]) ? found[1] : []) : [];
      }
      // simple array has no values
      return [];
    }
    if (typeof src === 'object') {
      return Array.isArray(src[keySnake]) ? src[keySnake] : [];
    }
    return [];
  };
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowAdvancedFilters(false);
      }
    }
    if (showAdvancedFilters) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    }
  }, [showAdvancedFilters])
  return (
    <div className="py-3 px-5 font-sans bg-gray-50">
      {!showConversationPage && <><div className='mb-4'>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Conversation Records</h1>
        <p className="text-sm text-gray-500">View and manage all recorded customer conversations</p>
      </div>
      
      <div className='bg-white rounded-lg shadow-sm p-4 mb-4'>
      <div className="flex justify-between mb-4 items-center">
        <div className="text-sm font-medium text-gray-700">Quick Filters</div>
        <div className="flex space-x-3">
          <button onClick={() => setIsDownloadModalOpen(true)} className="flex items-center px-4 py-2 rounded text-sm text-white hover:opacity-90" style={{ backgroundColor: "rgb(79, 70, 229)" }}>
            <Download className="h-4 w-4 mr-2" />
            Download
          </button>
        <button 
          className="flex items-center text-indigo-600 text-sm"
          onClick={toggleAdvancedFilters}
        >
          <FaFilter className="mr-2" />
          Show Advanced Filters
        </button>
        </div>
      </div>
      
      <div className="flex gap-4 mb-2">
      <input
          type="text"
          value={filters.conversation_id}
          onChange={(e) => handleQuickFilterChange(e, 'conversation_id')}
          placeholder="Conversation ID"
          className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input"
        />
      <ModernTimeDropdown isDisabled={role === 'agent'} placeholder="Select Agent" value={filters.agent} onChange={(e) => handleQuickFilterChange(e, 'agent')} options={dummyFilterData.agents}/>
      <ModernTimeDropdown placeholder="Select Time Duration" value={filters.time} onChange={(e) => handleQuickFilterChange(e, 'time')} options={dummyFilterData.times}/>
      <ModernTimeDropdown placeholder="Select Duration" value={advancedFilters.audioDuration} onChange={(e) => handleAdvancedInputChange(e, 'audioDuration')} options={dummyAdvancedFilterData.audioDuration}/>
      <ModernTimeDropdown placeholder="Select Mode" value={filters.mode} onChange={(e) => handleQuickFilterChange(e, 'mode')} options={['Live Conversation', 'Test Conversation']}/>
      </div>
      <div>
      {filters.time === "Custom Range" && (
            <div className="flex gap-4 mb-2">
              <div>
                <ModernDatePicker
                  placeholder="Start Date"
                  value={filters.customStart}
                  onChange={(e)=>handleQuickFilterChange(e, 'customStart')}
                  minDate={filters.customEnd ? new Date(new Date(filters.customEnd).getTime() - 90*24*60*60*1000) : undefined}
                  maxDate={filters.customEnd || undefined}
                />
              </div>
              <div>
              <ModernDatePicker
                placeholder="End Date"
                value={filters.customEnd}
                onChange={(e)=>handleQuickFilterChange(e, 'customEnd')}
                minDate={filters.customStart || undefined}
                maxDate={filters.customStart ? new Date(new Date(filters.customStart).getTime() + 90*24*60*60*1000) : undefined}
              />
              </div>
            </div>
          )}
      </div>
      {/* Filter Display */}
      <div className="flex gap-4 mb-4 mt-4 flex-wrap">
        {Object.keys(filters).map(
          (key) => {
            // Skip customStart and customEnd if time is not "Custom Range"
            if ((key === 'customStart' || key === 'customEnd') && filters.time !== 'Custom Range') {
              return null;
            }
            
            return filters[key] && (
              <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                <span className="capitalize text-indigo-600">{key} - {filters[key]}</span>
                {((key!=='time' && key !== segmentParameterData.id) && !(role === 'employee' && key === 'employee')) && <button
                  className="ml-2 text-gray-600"
                  onClick={() => setFilters((prev) => ({ ...prev, [key]: '' }))}
                >
                  <FaTimes />
                </button>}
              </div>
            );
          }
        )}
        {/* Show advanced filters that are set (excluding defaults) */}
        {Object.entries(advancedFilters).map(([key, val]) => {
          // skip if blank or default
          if (
            val === '' || val== null
          ) {
            return null;
          }
          if((key === 'agent_feedback_multiple' && val.filter((item)=>item.agent_feedback_parameter_score_lower!=null || item.agent_feedback_parameter_score_upper!=null).length > 0 )|| (key === 'business_insights_multiple' && val.filter((item)=>item.business_insight_value!=null).length > 0)){
            return (
              <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                <span className='capitalize text-indigo-600'>{key === 'agent_feedback_multiple' ? 'Agent Feedback' : 'Business Insights'} - {val.filter((item)=>key === 'agent_feedback_multiple' ? (item.agent_feedback_parameter_score_lower - item.agent_feedback_parameter_score_upper) : item.business_insight_value!=null).map((item)=>key === 'agent_feedback_multiple' ? item.agent_feedback_parameter : item.business_insight_key).join(', ')}</span>
              </div>
            )
          }
          if(key !== 'agent_feedback_multiple' && key !== 'business_insights_multiple'){
          return (
            <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
              <span className='capitalize text-indigo-600'>{key} - {String(!isNaN(val/1) ? Number(val).toFixed(0) : val)}</span>
              <button
                className="ml-2 text-gray-600"
                onClick={() => setAdvancedFilters((prev) => ({ ...prev, [key]: null }))}
              >
                <FaTimes />
              </button>
            </div>
          );
          }
        })}
      </div>
      <div className='flex items-center justify-end w-full'>
      <div className='flex items-center'>
          <div className="mr-4"><ModernTimeDropdown ariaLabel="Conversation type" width="w-48"
            value={({ call: 'Voice calls', chat: 'Chats', all: 'All conversations' })[filters.record_type || 'call']}
            options={['Voice calls', 'Chats', 'All conversations']} onChange={e => handleQuickFilterChange({ target: { value: ({ 'Voice calls': 'call', Chats: 'chat', 'All conversations': 'all' })[e.target.value] } }, 'record_type')} /></div>
          <label className='px-2 py-1.5 text-sm font-medium text-gray-700 focus:outline-none'><input type="checkbox" className="mr-2" checked={queuedCallsEnabled} disabled={!isVoiceFilter} onChange={(e)=>setShowQueuedCalls(e.target.checked)}/>Show Queued Calls</label>
        </div>
      </div>
    </div>
    
    {/* Advanced Filters Sidebar */}
    <div className={`fixed top-0 right-0 h-full bg-white border-l shadow-lg w-96 transition-transform duration-300 transform ${showAdvancedFilters ? 'translate-x-0' : 'translate-x-full'}`} style={{zIndex: "99999999999999"}}>
      <div className='bg-gray-50' style={{padding: "20px 24px",display: "flex",alignItems: "center",justifyContent: "space-between", borderBottom: "1px solid #00000012", height: "4rem"}}>
        <h2 className="text-lg font-medium mb-0 text-xl font-semibold text-gray-900">Advanced Filters</h2>
        <button onClick={toggleAdvancedFilters}>
          <FaClose />
        </button>
      </div>
      <div style={{overflowY: "auto", height: "calc(100vh - 4rem)"}}>
      <div className="space-y-4" style={{padding: "15px 0", paddingRight: "20px", paddingLeft: "1.5rem"}}>
        <div>
          <label className="block text-sm font-medium mb-2">Customer ID</label>
          <input class="global-input"type="text" placeholder="Enter Customer ID" className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input w-full"
          value={advancedFilters.customer_id} onChange={(e) => handleAdvancedInputChange(e, 'customer_id')} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Conversation Direction</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Direction" value={advancedFilters.conversation_direction} onChange={(e) => handleAdvancedInputChange(e, 'conversation_direction')} options={dummyAdvancedFilterData.conversation_directions}/>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Disconnect Type</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Type" value={advancedFilters.disconnect_type} onChange={(e) => handleAdvancedInputChange(e, 'disconnect_type')} options={dummyAdvancedFilterData.disconnect_types}/>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Disconnect Reason</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Reason" value={advancedFilters.disconnect_reason} onChange={(e) => handleAdvancedInputChange(e, 'disconnect_reason')} options={dummyAdvancedFilterData.disconnect_reasons}/>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Average Latency</label>
          <input class="global-input"type="text" placeholder="Enter Average Latency" className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input w-full"
          value={advancedFilters.average_latency} onChange={(e) => handleAdvancedInputChange(e, 'average_latency')} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Campaign ID</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Campaign ID" value={advancedFilters.campaign_id} onChange={(e) => handleAdvancedInputChange(e, 'campaign_id')} options={dummyAdvancedFilterData.campaign_ids}/>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Campaign Batch ID</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Campaign Batch ID" value={advancedFilters.campaign_batch_id} onChange={(e) => handleAdvancedInputChange(e, 'campaign_batch_id')} options={dummyAdvancedFilterData.campaign_batch_ids}/>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Transfer Status</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Transfer Status" value={advancedFilters.transfer_status} onChange={(e) => handleAdvancedInputChange(e, 'transfer_status')} options={dummyAdvancedFilterData.transfer_statuses}/>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Transfer Agent Answered</label>
          <ModernTimeDropdown width='w-full' placeholder="Select Transfer Agent Answered" value={advancedFilters.transfer_agent_answered} onChange={(e) => handleAdvancedInputChange(e, 'transfer_agent_answered')} options={dummyAdvancedFilterData.transfer_agent_answereds}/>
        </div>

        {/* Business Insights - Collapsible (matches Calls UI) */}
        <div className="bg-gray-100" style={{display: "flex", flexDirection: "column", height: "70px", alignItems: "center", justifyContent: "center"}}>
          <div
            className={`sections-headings ${expandedSections.businessInsights ? "expanded" : ""}`}
            onClick={() => setExpandedSections((prev)=>({...prev, businessInsights: !prev.businessInsights}))}
          >
            <h2 className="section-title" style={{fontSize: "15px", fontWeight: "500", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
              Business Insights {expandedSections.businessInsights ? <FaCaretDown /> : <FaCaretRight />}
            </h2>
          </div>
        </div>
        {expandedSections.businessInsights && (
          <div className='p-2 rounded-md'>
            {
              (advancedFilters.business_insights_multiple || []).map((item, index) => (
                <div className='m-4 flex flex-col items-center p-2 border border-gray-200 rounded-md bg-gray-100' key={index}>
                  <div className='mb-2 w-full'>
                   <label className="block text-sm font-medium mb-6 flex items-center justify-between">Business Insights Parameter 
                    <button className='px-2 py-1 rounded-md' onClick={()=>setAdvancedFilters((prev)=>({...prev, business_insights_multiple: prev.business_insights_multiple.filter((_, i) => i !== index)}))}><FaTimes/></button></label>
                   <ModernTimeDropdown width='w-full' placeholder="Select Parameter" value={item.business_insight_key || ''} onChange={(e) => updateBusinessInsights(index, 'business_insight_key', e.target.value)} options={getBusinessInsightKeys()}/>
                 </div>
                 {(item.business_insight_key || '') !== '' && (
                   <div className="mb-2 w-full">
                     <label className="block text-sm font-medium mb-2">
                       Parameter Value
                     </label>
                     <ModernTimeDropdown width='w-full'
                           placeholder="Select Value" 
                           value={item.business_insight_value || ''} 
                           onChange={(e) => updateBusinessInsights(index, 'business_insight_value', e.target.value)} 
                           options={getBusinessInsightValues(item.business_insight_key)}
                         />
                   </div>
                 )}
                </div>
              )
            )}
            <div className='flex items-center justify-end mx-4'>
              <button className='bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded-md text-sm' onClick={()=>setAdvancedFilters((prev)=>({...prev, business_insights_multiple: [...(prev.business_insights_multiple || []), {'business_insight_key': '', 'business_insight_value': null}]}))}>+ Add More</button>
            </div>
          </div>
        )}

      </div>
      </div>
    </div>

    <VoiceCallDownloadParametersModal
      filterMode={filterMode}
      setFilterMode={setFilterMode}
      setConversationIds={setConversationIds}
      setCustomerIds={setCustomerIds}
      isOpen={isDownloadModalOpen}
      onClose={() => setIsDownloadModalOpen(false)}
      quickFilterApproxCount={totalRecords}
      onApply={captureRecords}
    />

    {/* Table */}
    <div className="bg-white rounded-lg shadow-sm" style={{height: "50vh", overflowY: "auto"}}>
      {
        loading ? (
            <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
              <div className="loader"></div>
              <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
            </div>
        ) : queuedCallsEnabled ? (
          <table className="min-w-full divide-y divide-gray-200">
            <thead style={{ position: "sticky", top: "0"}}>
              <tr>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Conversation ID</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Customer ID</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Agent ID</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Status</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Created At</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Scheduled At</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Agent Priority</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {queuedCalls.map((convo) => (
                <tr key={convo.conversation_id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.conversation_id}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.customer_id}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.agent_id}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.status || 'Failed'}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDate(convo.createdat)}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDate(convo.scheduledat)}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.agent_priority}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                    <button
                      onClick={() => { setCancelQueuedCall(convo); setShowCancelQueuedCallModal(true); }}
                      className="px-2 py-1 text-xs rounded border border-red-300 text-red-600 hover:bg-red-50"
                    >
                      Cancel
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead style={{ position: "sticky", top: "0"}}>
              <tr>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Conversation ID</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Customer ID</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Agent ID</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Time</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Status</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Disconnect Type</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Conversation Direction</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Duration</th>
                <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredConversations.map((convo) => (
                <tr key={convo.conversation_id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.conversation_id}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.customerid }</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.agent_id}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDate(convo.record_time)}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.status}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.disconnect_type}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.conversation_direction}</td>
                  <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.duration}</td>
                  <td onClick={()=>handleCallDetail(convo.conversation_id)} className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem", cursor: "pointer"}}>View Details</td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      }
    </div>

    <CancelQueuedCallModal
      isOpen={showCancelQueuedCallModal}
      onClose={() => { if (!cancelQueuedCallApiRunning) { setShowCancelQueuedCallModal(false); setCancelQueuedCall(null); } }}
      onConfirm={handleConfirmCancelQueuedCall}
    />
    
    {/* Pagination */}
    <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
            <div className="flex-1 flex justify-between sm:hidden">
              <div onClick={handlePreviousPage} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Previous
              </div>
              <div onClick={handleNextPage} className="ml-3 inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Next
              </div>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <p className="text-sm text-gray-700">
                  Showing <span className="font-medium">{totalRecords === 0 ? 0 : (50 * (page - 1)) + 1}</span>
                  {" "}to <span className="font-medium">{Math.min(totalRecords, page * 50)}</span>
                  {" "}of <span className="font-medium">{totalRecords}</span> records
                </p>
              </div>
              <div>
                <nav className="z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                  <div onClick={handlePreviousPage} className="inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" style={{cursor: "pointer"}}>
                    Previous
                  </div>
                  <div onClick={handleNextPage} className="inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" style={{cursor: "pointer"}}>
                    Next
                  </div>
                </nav>
              </div>
            </div>
          </div></>}
      {
        showConversationPage && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowConversationPage(false); setSelectedCallID(null);}}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%", borderRadius: "10px"}}>
          <CallDetails selectedOption={service_id} open_type={handleClose} callIdProp={selectedCallID} selectedClientId={client_id}/>
          </div>
          </div>
          </div>
        )
      }
      <style jsx>
          {`
          .sections-headings {
                          cursor: pointer;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          padding: 15px;
                          border-radius: 10px;
                          transition: background 0.3s;
                          width: 100%;
                          }

                          .section-title {
                          font-size: 15px;
                          font-weight: 500;
                          display: flex;
                          align-items: center;
                          }
          `}              
        </style>
  </div>
);
};

export default ConversationRecords;
